/*
 * ElitePlus Email Configuration
 * 
 * HOW TO SET UP:
 * 1. Create a free account at https://www.emailjs.com
 * 2. Add your Hostinger SMTP as an Email Service (Service ID goes below)
 * 3. Create two Email Templates:
 *    - "Visitor Acknowledgment" template (Template ID goes in VISITOR_TEMPLATE_ID)
 *    - "Internal Notification" template (Template ID goes in INTERNAL_TEMPLATE_ID)
 * 4. Copy your Public Key from EmailJS Account > API Keys
 * 5. Fill in the values below and redeploy
 *
 * TEMPLATE PLACEHOLDERS (use these in your EmailJS templates):
 *   {{from_name}}        - Visitor's full name
 *   {{from_email}}       - Visitor's email
 *   {{company}}          - Visitor's company
 *   {{phone}}            - Visitor's phone
 *   {{service}}          - Selected service
 *   {{message}}          - Visitor's message
 *   {{reference_id}}     - Auto-generated enquiry reference
 *   {{submission_date}}  - Date of submission
 *   {{to_email}}         - Recipient email (for internal template)
 */

const EMAIL_CONFIG = {
  // ── EmailJS Credentials ────────────────────────────
  EMAILJS_PUBLIC_KEY: "HvtilmeZnCYM4k0iJ",
  EMAILJS_SERVICE_ID: "service_eliteplus_smtp",
  VISITOR_TEMPLATE_ID: "template_visitor",
  INTERNAL_TEMPLATE_ID: "template_internal",

  // ── Feature Toggles ────────────────────────────────
  emailEnabled: true,
  visitorEmailEnabled: true,
  internalEmailEnabled: true,

  // ── Internal Notification Recipients ───────────────
  internalToEmail: "info@eliteplus.io",
  additionalRecipients: "",
  ccEmail: "",
  bccEmail: "",

  // ── Visitor Email Settings ─────────────────────────
  visitorReplyTo: "info@eliteplus.io",
  visitorCc: "",
  visitorBcc: "",

  // ── Company Info (used in templates) ───────────────
  companyName: "ElitePlus Consulting",
  signatureName: "ElitePlus Consulting Team",
  signatureEmail: "info@eliteplus.io",
  signaturePhone: "+971 7 5011591",
  websiteUrl: "https://eliteplus.io",
  logoUrl: "",

  // ── Admin Panel Password ───────────────────────────
  // SHA-256 hash of your admin password
  // Default password: "Admin@123"
  // To generate a new hash, open browser console and run:
  //   crypto.subtle.digest('SHA-256', new TextEncoder().encode('YourPassword')).then(b => console.log(Array.from(new Uint8Array(b)).map(x=>x.toString(16).padStart(2,'0')).join('')))
  adminPasswordHash: "e86f78a8a3caf0b60d8e74e5942aa6d86dc150cd3c03338aef25b7d2d7e3acc7",
};

export default EMAIL_CONFIG;
